import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieBanner.module.css';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('ptp_cookie_consent');
    if (!consent) {
      // Small delay for better UX
      setTimeout(() => setVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('ptp_cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('ptp_cookie_consent', 'declined');
    setVisible(false);
    // Disable Google Analytics if declined
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)['ga-disable-G-1LT0WZSZ75'] = true;
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <p>
          We use cookies and similar technologies to improve your experience and analyse usage. 
          See our <Link to="/privacy">Privacy Policy</Link> for details.
        </p>
        <div className={styles.buttons}>
          <button onClick={handleDecline} className={styles.declineBtn}>
            Decline
          </button>
          <button onClick={handleAccept} className={styles.acceptBtn}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
